import { render } from "./PointHistoryGrantedInfo.vue?vue&type=template&id=5379a7aa&scoped=true&ts=true"
import script from "./PointHistoryGrantedInfo.vue?vue&type=script&lang=ts"
export * from "./PointHistoryGrantedInfo.vue?vue&type=script&lang=ts"

import "./PointHistoryGrantedInfo.vue?vue&type=style&index=0&id=5379a7aa&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5379a7aa"]])

export default __exports__